export const isDemoUser = (userInfo) => {
  return userInfo?.role_id === 2;
};
